"use client";

import { c as _c } from "react/compiler-runtime";
import { IconArrowRight } from "@tabler/icons-react";
import Link from "next/link";
import { Card } from "@/components/ui/card";
import { useSearchPanelStore } from "@/stores/useSearchPanelStore";
interface Props {
  keyword: string;
  query: string;
}
export function SearchProductRequestCta(t0) {
  const $ = _c(9);
  const {
    keyword,
    query
  } = t0;
  const close = useSearchPanelStore(_temp);
  const href = `/product-requests?q=${encodeURIComponent(query)}`;
  let t1;
  if ($[0] !== keyword) {
    t1 = <span className="text-sm">Looking for <span className="font-semibold">{keyword}</span>? We don't carry those — request it.</span>;
    $[0] = keyword;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconArrowRight className="size-4 shrink-0" aria-hidden="true" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <Card className="flex flex-row items-center justify-between gap-3 rounded-md border bg-muted/50 px-4 py-4 shadow-none transition-colors hover:bg-muted">{t1}{t2}</Card>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== close || $[6] !== href || $[7] !== t3) {
    t4 = <Link href={href} onClick={close} data-testid="search-product-request-cta" className="block rounded-md no-underline! focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring">{t3}</Link>;
    $[5] = close;
    $[6] = href;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
function _temp(state) {
  return state.close;
}